import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

const Header = () => (
	<header>

		<nav>


<a href="https://noda.run/">home</a> 



</nav>


	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js